<!-- Card -->
<section class="card mb-3">
  <div class="card-header card-collapse">
    <!-- Header -->
    <h2 class="accordion-header">
      <button
        class="accordion-button"
        [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
        (click)="isCollapsed = !isCollapsed"
        type="button"
        aria-controls="bradning"
      >
        <span class="fs-3">{{ 'general.branding' | translate }}</span>

        <i
          class="fa fa-fw"
          [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
          attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
          role="img"
        ></i>
      </button>
    </h2>

    <!-- End Header -->
  </div>

  <div *ngIf="!isCollapsed" id="bradning">
    <div class="card-body">
      <label class="form-label"> {{ 'general.logo' | translate }}</label>
      <div class="mb-4">
        <div
          class="col-12 col-lg-6"
          *ngIf="!primaryLogo?.value"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          <upload-file
            (onSubmitFile)="onSubmitLogo($event, 'primary_logo_image_path')"
          ></upload-file>
        </div>
        <div class="col-lg-6 col-xl-4 mb-2 mb-xl-0 d-flex align-items-start">
          <img
            class="rounded img-fluid"
            [src]="primaryLogoUrl$ | async"
            *ngIf="primaryLogoUrl$ | async"
            alt="{{ 'general.logo' | translate }}"
            id="primaryLogo"
          />

          <button
            type="button"
            class="btn btn-soft-danger btn-sm ms-4"
            (click)="onDeleteLogo('primary_logo_image_path')"
            [canSee]="[accessRights.ConfigurationOptions_delete]"
            *ngIf="primaryLogo?.value"
            aria-controls="primaryLogo"
          >
            <i
              role="img"
              class="fa fa-trash-alt"
              attr.aria-label="{{ 'general.delete' | translate }}"
            ></i>
          </button>
        </div>
      </div>
      <div class="mb-4">
        <label class="form-label">
          {{ 'general.logoWhite' | translate }}
        </label>
        <div class="row gx-2">
          <div
            class="col-12 col-lg-6"
            *ngIf="!primaryWhiteLogo?.value"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            <upload-file
              (onSubmitFile)="
                onSubmitLogo($event, 'primary_white_logo_image_path')
              "
            ></upload-file>
          </div>
          <div class="col-lg-6 col-xl-4 mb-2 mb-xl-0 d-flex align-items-start">
            <img
              class="rounded img-fluid bg-secondary bg-stripes"
              *ngIf="primaryWhiteLogoUrl$ | async"
              [src]="primaryWhiteLogoUrl$ | async"
              alt="{{ 'general.logoWhite' | translate }}"
              id="primaryWhiteLogo"
            />

            <button
              type="button"
              *ngIf="primaryWhiteLogo?.value"
              class="btn btn-soft-danger btn-sm ms-3"
              (click)="onDeleteLogo('primary_white_logo_image_path')"
              [canSee]="[accessRights.ConfigurationOptions_delete]"
              aria-controls="primaryWhiteLogo"
            >
              <i
                role="img"
                class="fa fa-trash-alt"
                attr.aria-label="{{ 'general.delete' | translate }}"
              ></i>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.favicon' | translate }}
          {{ 'general.adminPortal' | translate }}</label
        >
        <div class="row gx-2">
          <div
            class="col-12 col-lg-6"
            *ngIf="!faviconAdminPortal?.value"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            <upload-file
              (onSubmitFile)="onSubmitLogo($event, 'favicon_path_admin_portal')"
            ></upload-file>
          </div>
          <div class="col-lg-4 col-xl-2 mb-2 mb-xl-0 d-flex align-items-start">
            <img
              *ngIf="faviconAdminPortalUrl$ | async"
              [src]="faviconAdminPortalUrl$ | async"
              alt="{{ 'general.favicon' | translate }} {{
                'general.adminPortal' | translate
              }}"
              class="img-fluid py-2 px-4"
              id="faviconAdminPortal"
            />

            <button
              type="button"
              *ngIf="faviconAdminPortal?.value"
              class="btn btn-soft-danger btn-sm"
              (click)="onDeleteLogo('favicon_path_admin_portal')"
              [canSee]="[accessRights.ConfigurationOptions_delete]"
              aria-controls="faviconAdminPortal"
            >
              <i
                role="img"
                class="fa fa-trash-alt"
                attr.aria-label="{{ 'general.delete' | translate }}"
              ></i>
            </button>
          </div>
        </div>
      </div>

      <div class="">
        <label class="form-label">
          {{ 'general.favicon' | translate }}
          {{ 'general.consumerFrontend' | translate }}</label
        >
        <div class="row gx-2">
          <div
            class="col-12 col-lg-6"
            *ngIf="!faviconConsumerFrontend?.value"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            <upload-file
              (onSubmitFile)="
                onSubmitLogo($event, 'favicon_path_consumer_frontend')
              "
            ></upload-file>
          </div>
          <div class="col-lg-4 col-xl-2 mb-2 mb-xl-0 d-flex align-items-start">
            <img
              *ngIf="faviconConsumerFrontendUrl$ | async"
              [src]="faviconConsumerFrontendUrl$ | async"
              alt=" {{ 'general.favicon' | translate }} {{
                'general.consumerFrontend' | translate
              }}"
              class="img-fluid py-2 px-4"
              id="faviconCF"
            />

            <button
              type="button"
              *ngIf="faviconConsumerFrontend?.value"
              class="btn btn-soft-danger btn-sm"
              (click)="onDeleteLogo('favicon_path_consumer_frontend')"
              [canSee]="[accessRights.ConfigurationOptions_delete]"
              aria-controls="faviconCF"
            >
              <i
                role="img"
                class="fa fa-trash-alt"
                attr.aria-label="{{ 'general.delete' | translate }}"
              ></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <form
      [formGroup]="form"
      (ngSubmit)="onFormSubmit()"
      #formRef="ngForm"
      [patchForm]="formValues"
      [canEdit]="[accessRights.ConfigurationOptions_write]"
      [canEdit]="[accessRights.Settings_write]"
    >
      <div class="card-body">
        <div class="mb-4">
          <label class="form-label">{{
            'configurationOptionModule.browserTitle' | translate
          }}</label>

          <input
            type="text"
            class="form-control"
            formControlName="browser_title"
          />
        </div>

        <div class="mb-4" *ngIf="showCustomFontsOption">
          <label class="form-label">{{
            'configurationOptionModule.customFontFamily' | translate
          }}</label>
          <ng-select
            [items]="googleFonts$ | async"
            [multiple]="false"
            [searchable]="true"
            bindLabel="name"
            bindValue="name"
            formControlName="custom_font_family"
            [closeOnSelect]="true"
          >
          </ng-select>
        </div>
      </div>
      <div class="card-footer justify-content-end d-flex">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
          *ngIf="!(isLoading$ | async); else isLoadingSpinner"
        >
          {{ 'general.save' | translate }}
        </button>

        <ng-template #isLoadingSpinner>
          <div
            class="spinner-border"
            role="status"
            attr.aria-label="{{ 'general.loading' | translate }}"
          >
          </div>
        </ng-template>
      </div>
    </form>
  </div>
</section>
<!-- End Card -->
